import script from "./Step2Appearance.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2Appearance.vue?vue&type=script&setup=true&lang=js"

import "./Step2Appearance.vue?vue&type=style&index=0&id=52dc5ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52dc5ba6"]])

export default __exports__